import {Worker} from "../util";

export default class PoziadavkaEditCtrl {

  static resolve = {
    uzivatelia: (UzivatelService) => UzivatelService.list(),
    typy: (PoziadavkaService) => PoziadavkaService.getTypes(),
    zakaznici: (ZakaznikService) => ZakaznikService.list(),
    pobockaProvider: (ZakaznikService) => (zakId) => ZakaznikService.listPobocky(zakId),
    osobaProvider: (AdresarService) => (zakId, pobockaId) => AdresarService.list(zakId, pobockaId),
    projektProvider: (ProjektService) => (search, zakId, pobockaId) => ProjektService.refList({search: search, zakaznikId: zakId, pobockaId: pobockaId}),
    defaultProjekt: ($stateParams, ProjektService) => {
      if($stateParams.projektId){
        return ProjektService.get($stateParams.projektId)
      }
      return null;
    }
  };

  constructor(PoziadavkaService, projektProvider, $stateParams, $state, pobockaProvider, osobaProvider, typy, uzivatelia, zakaznici, defaultProjekt) {
    this.PoziadavkaService = PoziadavkaService;

    this.$state = $state;
    this.poziadavkaId = $stateParams.id;
    this.$stateParams = $stateParams;
    this.loadPoziadavka = Worker(this._loadPoziadavka);
    this.zakaznici = [{nazov: "Žiaden zákazník"}].concat(zakaznici);

    this.pobockaProvider = pobockaProvider;
    this.osobaProvider = osobaProvider;
    this.projektProvider = (search) => projektProvider(search, (this.poziadavka.zakaznik||{}).id, (this.poziadavka.pobocka||{}).id);

    this.savePoziadavka = Worker(this._savePoziadavka);

    this.pobocky = [{nazov: "Žiaden objekt"}];
    this.osoby = [{celemeno: "Aktuálny užívateľ"}];

    this.uzivatelia = uzivatelia;
    this.typOptions = typy;
    this.prilohy = [];
    this.defaultProjekt = defaultProjekt;

    this.loadPoziadavka();
  }

  onZakaznikChange(){
    if(this.poziadavka && this.poziadavka.zakaznik && this.poziadavka.zakaznik.id){
      this.pobockaProvider(this.poziadavka.zakaznik.id).then(pobocky => {
        this.pobocky = [{nazov: "Žiaden objekt"}].concat(pobocky);
        if(this.poziadavka && this.poziadavka.pobocka && this.poziadavka.pobocka.id && !this.pobocky.find(o => o.id == this.poziadavka.pobocka.id)){
          this.pobocky.push(this.poziadavka.pobocka);
        }
      })
    }
    this.onPobockaChange();
  }

  onPobockaChange(){
    this.osobaProvider((this.poziadavka.zakaznik||{}).id, (this.poziadavka.pobocka||{}).id).then(osoby => {
      this.osoby = [{celemeno: "Aktuálny užívateľ"}].concat(osoby);
      if(this.poziadavka && this.poziadavka.ziadatel && this.poziadavka.ziadatel.id && !this.osoby.find(o => o.id == this.poziadavka.ziadatel.id)){
        this.osoby.push(this.poziadavka.ziadatel);
      }
    });
  }

  onTypChange(){
    if(this.poziadavka.typ && this.poziadavka.typ.zodpovednyUzivatel){
      this.poziadavka.zodpovedny = this.poziadavka.typ.zodpovednyUzivatel;
    }
  }

  showPoziadavka(poziadavka) {
    if(!poziadavka.id && this.$stateParams.typ){
      poziadavka.typ = {id: +this.$stateParams.typ};
    }
    if(!poziadavka.id && this.$stateParams.zakaznikId){
      poziadavka.zakaznik = {id: +this.$stateParams.zakaznikId}
    }
    if(!poziadavka.id && this.defaultProjekt){
      poziadavka.projekt = {id: this.defaultProjekt.id, cisloNazov: this.defaultProjekt.cislo+" "+this.defaultProjekt.nazov};
    }
    if(!poziadavka.id && this.$stateParams.pobockaId){
      poziadavka.pobocka = {id: +this.$stateParams.pobockaId}
    }

    this.poziadavka = poziadavka;
    if(this.poziadavkaId !== this.poziadavka.id){
      this.$state.go(this.$state.current.name, {id: this.poziadavka.id});
    }
    this.onZakaznikChange();
  }

  _loadPoziadavka() {
    return this.PoziadavkaService.get(this.poziadavkaId)
      .then(poziadavka => this.showPoziadavka(poziadavka))
  }

  _savePoziadavka(){
    return this.PoziadavkaService.save(this.poziadavka)
      .then(poziadavka => this.showPoziadavka(poziadavka))
      .then(() => {
        if(this.prilohy.length > 0){
          return this.PoziadavkaService.addPoznamka({
            poziadavka: {id: this.poziadavka.id},
            text: "Priložené súbory",
            prilohy: this.prilohy
          });
        }
      })
      .then(() => this.$state.go("poziadavka", {id: this.poziadavka.id}));
  }
}


// WEBPACK FOOTER //
// ./src/poziadavky/PoziadavkaEditCtrl.js